import { constants } from "@layout/constants";
import { spacing } from "@layout/spacing";
import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "400px",
    margin: "0 auto",
    width: "100%",
    padding: `0 ${constants.divPadding}px`,
    boxSizing: "border-box",
    marginTop: -spacing.xl,
  },
  text: {
    textAlign: "center",
  },
};
